module.exports = __webpack_public_path__ + "media/images/vedett_allatok/Vedett_dupla-3038bf029bcc762ab970d1be1e7d8f8b.jpg";